/**
 * This code will keep track of the elements with 'position: sticky' and add a class 'stuck' to them when they are sticking.
 */
(() => {

    function getScrollableAncestor(element) {
        while (element) {
            const overflowY = window.getComputedStyle(element).overflowY;
            if (overflowY === 'auto' || overflowY === 'scroll') {
                return element;
            }
            element = element.parentElement;
        }
        return document.documentElement; // Fallback to the document element
    }

    function isStuck(element) {
        const scrollableAncestor = getScrollableAncestor(element);
        const elementRect = element.getBoundingClientRect();
        const ancestorRect = scrollableAncestor.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(element);
        const top = parseFloat(computedStyle.top);
        const ancestorScrollTop = scrollableAncestor.scrollTop;

        // Check if the element is in its "stuck" position
        return elementRect.top <= ancestorRect.top + top + ancestorScrollTop;
    }

    function applyStuckCSS(element, stuckClass) {
        if (isStuck(element)) {
            element.classList.add(stuckClass);
        } else {
            element.classList.remove(stuckClass);
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        const stickyElements = document.querySelectorAll('.sticky');
        const stuckClass = 'stuck';

        window.addEventListener('scroll', () => {
            stickyElements.forEach(stickyElement => applyStuckCSS(stickyElement, stuckClass));
        });
        window.addEventListener('resize', () => {
            stickyElements.forEach(stickyElement => applyStuckCSS(stickyElement, stuckClass));
        });

        // Initial check
        stickyElements.forEach(stickyElement => applyStuckCSS(stickyElement, stuckClass));
    });

})();
